import React from 'react';
import { Brain, Lightbulb, Zap, Target, Calculator, Puzzle } from 'lucide-react';
import { skills } from '../mock';

const iconMap = { Brain, Lightbulb, Zap, Target, Calculator, Puzzle };

const Categories = () => {
  return (
    <section id="categories" className="py-14 sm:py-20 lg:py-24 bg-[#2A1810]">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-[#F4C430] text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.35em] uppercase">Six brain skills</p>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5EDE0] leading-tight">
            A friendly workout for every side of your mind
          </h2>
          <p className="mt-3 sm:mt-4 text-[#D9C9B3] text-base sm:text-lg">
            From logic to memory, we shape short daily sessions that feel more like play than study — designed for every age
          </p>
        </div>

        {/* Compact grid on mobile (as per doc) */}
        <div className="mt-8 sm:mt-12 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-5 lg:gap-6">
          {skills.map((s) => {
            const Ico = iconMap[s.icon];
            return (
              <div
                key={s.title}
                className="group relative rounded-2xl p-4 sm:p-6 lg:p-7 bg-[#3D2817] border border-[#4a3221] hover:border-[#F4C430]/60 transition-all hover:-translate-y-0.5 cursor-pointer overflow-hidden"
              >
                <div
                  className="absolute -top-16 -right-16 h-40 w-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: `radial-gradient(closest-side, ${s.color}22, transparent)` }}
                />
                <div
                  className="h-10 w-10 sm:h-12 sm:w-12 rounded-xl grid place-items-center"
                  style={{ background: `${s.color}20`, border: `1px solid ${s.color}55` }}
                >
                  <Ico size={20} style={{ color: s.color }} />
                </div>
                <h3 className="mt-3 sm:mt-5 font-serif text-lg sm:text-2xl text-[#F5EDE0]">{s.title}</h3>
                <p className="mt-1 sm:mt-2 text-[#B8A990] text-xs sm:text-sm">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
